import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    container: {
        position: 'fixed',
        bottom: 112,
        right: 32,
        width: 64,
        height: 64,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
        boxShadow: '0px 10px 40px rgba(186, 184, 176, 0.2)',
        borderRadius: 16,
        color: '#4D4D4D'
    },
    icon: {
        width: 32,
        height: 32
    }
});
